import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back',
    description: {
      acceptedTypes: 'Accepted files: **JPG, PNG**',
      maxSize: '**{maxSize}MB** maximum',
    },
    dropZone: {
      browse: 'or **browse** to choose a file',
      title: 'Drop your logo here',
    },
    submit: 'Add your logo',
    title: 'Add your logo to your quotes and invoices',
  },
  fr: {
    back: 'Retour',
    description: {
      acceptedTypes: 'Fichiers acceptés : **JPG ou PNG**',
      maxSize: '**{maxSize} Mo** maximum',
    },
    dropZone: {
      browse: 'ou **sélectionnez** un fichier',
      title: 'Déposez votre logo ici',
    },
    submit: 'Ajouter mon logo',
    title: 'Ajoutez votre logo sur vos devis et factures',
  },
} as const);

export default locales;
